import {ChecklistShape} from '../../services/checklist-service';

export const RECEIVE_CHECKLIST = 'CHECKLIST/RECEIVE_CHECKLIST';

export const receiveChecklist = (checklist: ChecklistShape) => ({
  type: RECEIVE_CHECKLIST,
  payload: checklist,
});
